import { BlockStack, List, Modal } from "@shopify/polaris";
import { modalsType } from "../hooks/modals";
const TopModal = (props: modalsType) => {
  const { modals, changeModals } = props;
  const {
    open,
    title,
    message,
    children,
    primaryAction,
    secondaryActions,
    lists,
  } = modals;
  const onClose = () => {
    !modals.notClose &&
      changeModals({
        open: false,
        primaryAction: undefined,
        secondaryActions: undefined,
        children: undefined,
        lists: undefined,
        message: undefined,
      });
  };
  return (
    <Modal
      {...{ open, title, onClose }}
      primaryAction={primaryAction}
      secondaryActions={secondaryActions}
    >
      <Modal.Section>
        <BlockStack gap="200">
          {children ? children : <p>{message}</p>}
          {lists && (
            <List>
              {lists.map((list, index) => {
                return <List.Item key={`${list}-${index}`}>{list}</List.Item>;
              })}
            </List>
          )}
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
};

export default TopModal;
